import { Box, Button} from "@mui/material";
import { CustomProgramUpdateCommand, ProgramOptions } from "../../api/models/program";
import { BasicTextBox } from "../../shared/basicTextBox";
import { BasicDropDown } from "../../shared/basicDropDown";
import { useState } from "react";
import { numGamesPerPageList, numMembersPerPageList, numSpecialPagesList } from "../../models/dropDownItemViewModel";
import { UploadImageButton } from "../../shared/uploadImageButton";


export interface UpdateProgramPanelProps {
    programOptions:ProgramOptions,
	onUpdate: (optionUpdates: CustomProgramUpdateCommand) => void;
    onChangeOpponentLogo: (logo: string) => void;
    onChangeSpecialSheet: (pageIndex: number, specialSheet: string) => void;
}

export function UpdateProgramPanel(props: UpdateProgramPanelProps) {

    const [theme, setTheme] = useState<string>(props.programOptions.theme);
    const [membersPerPage, setMembersPerPage] = useState<number>(props.programOptions.membersPerPage);
    const [gamesPerPage, setGamesPerPage] = useState<number>(props.programOptions.gamesPerPage);

    const [specialPageIndex, setSpecialPageIndex] = useState<number>(1);
    const [selectedSpecialPageLink, setSelectedSpecialPageLink] = useState<string>(props.programOptions.customPageImageLinks[0]);

    async function updateProgramOptions() {

        const updatedOptions: CustomProgramUpdateCommand = {
            theme,
            membersPerPage,
            gamesPerPage
        };

        props.onUpdate(updatedOptions);
    }

    function changeSpecialSheetHandler(imageData: string) {
        props.onChangeSpecialSheet(specialPageIndex, imageData);
    }

    function selectPageIndexHandler(pageIndex: number) {
        setSpecialPageIndex(pageIndex);
        setSelectedSpecialPageLink(props.programOptions.customPageImageLinks[pageIndex - 1]);
    }

function formContent() {
        return (
            <>

                <Box mb={2}>
                   Name: {props.programOptions.name}
                </Box>
                <Box>
                    
                        <Box>


                            <Box component="form" noValidate autoComplete="off"></Box>
                            <Box mb={2}>

                                <BasicTextBox id='txtTheme'
                                    label='Theme'
                                    maxLength={20}
                                    width={275}
                                    value={theme}
                                    onChange={(e) => setTheme(e.target.value)} />


                            </Box>

                            <Box mb={2}>

                                <BasicDropDown id='membersPerPage'
                                    label='Members Per Page'
                                    width={275}
                                    value={membersPerPage}
                                    items={numMembersPerPageList}
                                    onChange={(e) => setMembersPerPage(parseInt(e.target.value, 10))} />

                            </Box>

                            <Box mb={2}>

                         <BasicDropDown id='gamesPerPage'
                                    label='Games Per Page'
                                    width={275}
                                    value={gamesPerPage}
                                    items={numGamesPerPageList}
                                    onChange={(e) => setGamesPerPage(parseInt(e.target.value, 10))} />
                            </Box>

                          <Box>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    updateProgramOptions();
                                }}
                            >
                                Save Program Options
                            </Button>

                            </Box>

                            <br/><br/>
                             <h3>Opponent Logo Update</h3>

                            <Box>
                                { !props.programOptions.opponentLogoLink && <span>No opponent logo uploaded</span>}
                                {props.programOptions.opponentLogoLink && <img src={props.programOptions.opponentLogoLink} alt="Opponent Logo" style={{ maxWidth: '200px', maxHeight: '200px' }} />}
                            </Box>
                            <Box>
                                 <UploadImageButton
                                           id="uploadImage"
                                           onChange={props.onChangeOpponentLogo}
                                           aspectRatio={1}
                                         />
                            </Box>
                            <p>Ideal size is 500 X 500</p>

                             <br/><br/>
                             <h3>Special Sheet Update</h3>

                              <Box mb={2}>

                                <BasicDropDown id='specialPageIndex'
                                    label='Special Page Index'
                                    width={275}
                                    value={specialPageIndex}
                                    items={numSpecialPagesList}
                                    onChange={(e) => selectPageIndexHandler(parseInt(e.target.value, 10))} />

                            </Box>

                            <Box>
                                { !selectedSpecialPageLink && <span>No special page uploaded</span>}
                                {selectedSpecialPageLink && <img src={selectedSpecialPageLink} alt="Special Page" 
                                     style={{ maxWidth: '200px', maxHeight: '200px' }} />}
                            </Box>
                            <Box>
                                 <UploadImageButton
                                           id="uploadPageImage"
                                           onChange={changeSpecialSheetHandler}
                                           aspectRatio={0.625}
                                         />
                            </Box>
                            <p>Ideal size is 600 X 960</p>

                            

                        </Box>
                        
                    
                </Box>


            </>
        );
    }
	









    return (
        <Box>
			<h2>Add Custom Program</h2>
			{formContent()}
		</Box>
    );
}